import React from 'react';
import { XMLProp } from 'pages/Chat/MarkdownRender';
import {
	Box,
	styled,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableRow,
	Typography,
} from '@mui/material';
import { MOBILE_BREAK_POINTS } from 'data/constant';

const ResponsiveCell = styled(TableCell)(({ theme }) => ({
	borderColor: theme.palette.divider,
	minWidth: 200,
	width: '50%', // keep two-even columns on desktop
	verticalAlign: 'top',

	[`@media (max-width: ${MOBILE_BREAK_POINTS}px)`]: {
		minWidth: 'auto',
		width: 'auto',
		maxWidth: '50%',
		padding: '10px 10px',
	},
}));

const ResponsiveTypography = styled(Typography)(({ theme }) => ({
	fontWeight: 600,
	color: '#4C535A',
	wordBreak: 'break-word',
	overflowWrap: 'anywhere', // breaks very long tokens
	whiteSpace: 'normal',
	[`@media (max-width:${MOBILE_BREAK_POINTS}px)`]: {
		fontWeight: 500,
		fontSize: theme.typography.caption.fontSize,
		lineHeight: theme.typography.caption.lineHeight,
	},
}));

export const PropsTable: React.FC<{ propsList: XMLProp[] }> = ({
	propsList,
}) => {
	const rows = propsList.filter((p) => p.value);
	if (!rows.length) return null;

	return (
		<Box sx={{ borderRadius: 2, overflow: 'hidden', width: '100%', mb: 1 }}>
			<TableContainer sx={{ width: '100%', overflowX: 'auto' }}>
				<Table size="small" sx={{ tableLayout: 'fixed' }}>
					<TableBody>
						{rows.map((p, idx) => (
							<TableRow
								key={`${p.name}-${idx}`}
								sx={{
									maxWidth: '100%',
									backgroundColor: '#F8F9FA',
									borderBottom: '1px solid #EAECEF',
									'&:last-child td': { borderBottom: 'none' },
								}}
							>
								<ResponsiveCell>
									<ResponsiveTypography variant="body2">
										{p.name}
									</ResponsiveTypography>
								</ResponsiveCell>
								<ResponsiveCell>
									<ResponsiveTypography variant="body2">
										{p.value}
										{p.unit ? ` ${p.unit}` : ''}
									</ResponsiveTypography>
								</ResponsiveCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		</Box>
	);
};
